<template>
    <div
        v-if="legends && (legends.parking.length || legends.pantry.length)"
        :class="['parking-legends', {'is-open': isOpen}]"
    >
        <button class="button-circle button-circle_theme_stroke parking-legends__info-button" @click="isOpen = true">
            <iconInfo className="parking-legends__svg-info"/>
        </button>

        <div class="parking-legends__overlay">
            <button class="button-circle button-circle_theme_stroke visual-sly__close-button" @click="isOpen = false">
                <iconClose className="visual-rotate__svg-close"/>
            </button>

            <div class="parking-legends__wrapper">
                <div v-if="legends.parking.length" class="parking-legends__list">
                    <div
                        v-for="legend in legends.parking"
                        :key="legend.id"
                        class="parking-legends__item"
                    >
                        <div class="parking-legends__img">
                            <img :src="legend.img" alt="Машиноместо">
                        </div>
                        <div class="parking-legends__info">
                            <div class="parking-legends__caption">Машиноместо</div>
                            <div class="parking-legends__area">{{ legend.area }} м&sup2;</div>
                        </div>
                    </div>
                </div>
                <div v-if="legends.pantry.length" class="parking-legends__list">
                    <div
                        v-for="legend in legends.pantry"
                        :key="legend.id"
                        class="parking-legends__item"
                        @click="clickLegend(legend.id)"
                    >
                        <div class="parking-legends__img">
                            <img :src="legend.img" alt="Кладовая">
                        </div>
                        <div class="parking-legends__info">
                            <div class="parking-legends__caption">Кладовая</div>
                            <div class="parking-legends__area">{{ legend.area }} м&sup2;</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang='scss'>
    @import "./Legend.scss";
</style>

<script>
import iconClose from '../../Icons/icon-close';
import iconInfo from '../../Icons/icon-legend-info';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            legends: {
                parking: [],
                pantry : []
            },
            isOpen: false
        };
    },

    components: {
        iconInfo,
        iconClose
    },

    created() {
        this.getLegends();
    },

    computed: {
        ...mapGetters({
            filters: 'GET_FILTERS',
            view   : 'GET_VIEW'
        })
    },

    watch: {
        isOpen(val) {
            /* Отпускаем у хеадера z-index  */
            if (!this.header) {
                this.header = document.querySelector('.header');
                this.selector = document.querySelector('.parking__section-selector');
            }

            if (val) {
                this.header.style.zIndex = 1;
                this.selector.style.zIndex = 1;
            } else {
                this.header.removeAttribute('style');
                this.selector.removeAttribute('style');
            }
        }
    },

    methods: {
        getLegends() {
            if (this.filters.size) {
                for (const item in this.filters.size) {
                    if (this.filters.size[item]['disabled'] === false) {
                        if (this.filters.size[item]['type'] === 'parking') {
                            this.legends.parking.push(this.filters.size[item]);
                        } else {
                            this.legends.pantry.push(this.filters.size[item]);
                        }
                    }
                }
            }
        }
    }
};
</script>
